import { render, staticRenderFns } from "./postReComment.vue?vue&type=template&id=2a933686&scoped=true&"
import script from "./postReComment.vue?vue&type=script&lang=js&"
export * from "./postReComment.vue?vue&type=script&lang=js&"
import style0 from "./postReComment.vue?vue&type=style&index=0&id=2a933686&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a933686",
  null
  
)

export default component.exports